import { render, staticRenderFns } from "./ThemesEditorTab.vue?vue&type=template&id=046e757c&scoped=true"
import script from "./ThemesEditorTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ThemesEditorTab.vue?vue&type=style&index=0&id=046e757c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046e757c",
  null
  
)

export default component.exports